import { createContext, useContext, useRef, useState } from "react";

const SplineContext = createContext();

export function SplineProvider({ children }) {
  const splineObjectRef = useRef(null);
  const splineAppRef = useRef(null); // <-- sad je ovo prava Spline instanca
  const stateOneRef = useRef(null);
  const stateTwoRef = useRef(null);
  const groupScaleRef = useRef(null);
  const [isSplineReady, setIsSplineReady] = useState(false);

  const setSplineData = (
    object,
    splineApp,
    stateOne,
    stateSecond,
    groupScale
  ) => {
    splineObjectRef.current = object;
    splineAppRef.current = splineApp;
    stateOneRef.current = stateOne;
    stateTwoRef.current = stateSecond;
    groupScaleRef.current = groupScale;
    setIsSplineReady(true);
  };

  return (
    <SplineContext.Provider
      value={{
        splineObjectRef,
        splineAppRef,
        stateOneRef,
        stateTwoRef,
        groupScaleRef,
        isSplineReady,
        setSplineData,
      }}
    >
      {children}
    </SplineContext.Provider>
  );
}

export const useSpline = () => useContext(SplineContext);
